import React from 'react';
import LedgerDatasetTableShell, { LedgerDatasetTableShellProps } from '../shared/LedgerDatasetTableShell';

type ARCustomersTableProps = Omit<LedgerDatasetTableShellProps, 'view' | 'accountingSource'>;

const ARCustomersTable: React.FC<ARCustomersTableProps> = (props) => (
    <LedgerDatasetTableShell {...props} view="ar" accountingSource="ar_customers" />
);

export default ARCustomersTable;
